import {createContext} from 'react'
import {Field, FieldDocument, Section, Sheet} from './Sheet'

export interface Table_Item {
  _id: string
  label: string
}

export interface Type {
  _id: string
  nombre: string
  identificador: string
}

interface SheetContextProps {
  searchTerm: string
  setSearchTerm: (value: string) => void
  currentPage: number
  setCurrentPage: (value: number) => void
}

interface SheetEditContextProps {
  isEntityModalOpen: boolean
  openEntityModal: () => void
  closeEntityModal: () => void
  previewMode: 'Colaborador' | 'Administrador'
  setPreviewMode: (mode: 'Colaborador' | 'Administrador') => void
  isSectionModalOpen: boolean
  openSectionModal: () => void
  closeSectionModal: () => void
  isFieldModalOpen: boolean
  openFieldModal: () => void
  closeFieldModal: () => void
  isDocumentModalOpen: boolean
  openDocumentModal: () => void
  closeDocumentModal: () => void
  isAssignmentModalOpen: boolean
  openAssignmentModal: () => void
  closeAssignmentModal: () => void
  isAssignmentRequeridoModalOpen: boolean
  openAssignmentRequeridoModal: () => void
  closeAssignmentRequeridoModal: () => void
  isPreviewModalOpen: boolean
  openPreviewModal: (mode: 'Colaborador' | 'Administrador') => void
  closePreviewModal: () => void
  sheetData: Sheet
  setData: (value: Sheet) => void
  sectionData: Section
  setSectionData: (value: Section) => void
  fieldData: Field
  setFieldData: (value: Field) => void
  fieldDocumentData: FieldDocument
  setFieldDocumentData: (value: FieldDocument) => void
  tables: Table_Item[]
  setTables: (value: Table_Item[]) => void
  types: Type[]
  setTypes: (value: Type[]) => void
  formDataFirmas: {idproceso: string; unidad: string}
  setFormDataFirmas: (value: {idproceso: string; unidad: string}) => void
}

const SheetContext = createContext<SheetContextProps>({
  searchTerm: '',
  setSearchTerm: (value) => {},
  currentPage: 1,
  setCurrentPage: (value) => {},
})

const SheetEditContext = createContext<SheetEditContextProps>({
  isEntityModalOpen: false,
  openEntityModal: () => {},
  closeEntityModal: () => {},
  previewMode: 'Administrador',
  setPreviewMode: () => {},
  isSectionModalOpen: false,
  openSectionModal: () => {},
  closeSectionModal: () => {},
  isFieldModalOpen: false,
  openFieldModal: () => {},
  closeFieldModal: () => {},
  isDocumentModalOpen: false,
  openDocumentModal: () => {},
  closeDocumentModal: () => {},
  isAssignmentModalOpen: false,
  openAssignmentModal: () => {},
  closeAssignmentModal: () => {},
  isAssignmentRequeridoModalOpen: false,
  openAssignmentRequeridoModal: () => {},
  closeAssignmentRequeridoModal: () => {},
  isPreviewModalOpen: false,
  openPreviewModal: () => {},
  closePreviewModal: () => {},
  sheetData: {
    name: '',
    type: '',
    description: '',
    sections: [],
  },
  setData: (value) => {},
  sectionData: {
    id: '',
    name: '',
    description: '',
    dynamic: false,
    fields: [],
    filter: false,
  },
  setSectionData: (value) => {},
  fieldData: {
    id: '',
    name: '',
    tag: '',
    isDependent: false,
    responseType: '',
    comment: '',
    visible: true,
    editable: false,
    required: false,
    actualizable: false,
    collectionName: '',
    options: [],
    tablaData: [],
    type: [],
    assignedTo: '',
    dependentField: '',
    dependentFieldResponse: '',
    variable: false,
  },
  setFieldData: (value) => {},
  fieldDocumentData: {
    id: '',
    tipo: '',
    titulo: '',
    obligatorio: false,
  },
  setFieldDocumentData: (value) => {},
  tables: [],
  setTables: (value) => {},
  types: [],
  setTypes: (value) => {},
  formDataFirmas: {idproceso: '', unidad: ''},
  setFormDataFirmas: (value) => {},
})

export {SheetContext, SheetEditContext}
